import React from 'react';

// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router';

import { LoadingSpinner, Page } from '../../components/layouts';
import { LoginDialog } from '../../components/partials';
import {
  DispatchProps,
  StateProps,
} from '../../weborder/component/PhoneNumber';

type LoginRoute = RouteComponentProps<
  {
    dlid?: number;
  },
  {}
>;

type Props = StateProps & DispatchProps & LoginRoute;

export function Login(props: Props): JSX.Element {
  const {
    AppConfig: appConfig,
    enableRememberMe,
    languageCode,
    LastRestaurantUrl: lastRestaurantUrl,
    params,
    PhoneNumberConfig: phoneNumberConfig,
    rememberMe,
    setRememberMe,
    translate,
  } = props;

  if (appConfig.status !== 'success') {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Page pageName="login">
        <LoginDialog
          configData={appConfig.data}
          enableRememberMe={enableRememberMe}
          languageCode={languageCode}
          lastRestaurantUrl={lastRestaurantUrl}
          phoneNumberConfig={phoneNumberConfig}
          params={params}
          rememberMe={rememberMe}
          setRememberMe={setRememberMe}
          showDialog={true}
          translate={translate}
        />
      </Page>
    </>
  );
}
